export function preloadUrl(link) {
  window.PRELOADED_ROOM_URLS = window.PRELOADED_ROOM_URLS || {};

  if (!link || window.PRELOADED_ROOM_URLS[link]) {
    return;
  }

  window.PRELOADED_ROOM_URLS[link] = true;
  fetch(link);
}

export function preloadRoomCardHoverInteractions() {
  document.addEventListener('mouseover', (event) => {
    const roomCard = event.target.closest?.('.c-room-card');

    if (roomCard) {
      // Grab the first <a> inside the card
      const link = roomCard.querySelector('a');
      preloadUrl(link?.href);
    }
  });
}
